const setTitle = (title: string) => {
  return title
    ? `${title} | Granary Capital HR Portal`
    : "Granary Capital HR Portal";
};

const authRoutes = [
  {
    path: "/auth/verify-sso",
    name: "auth.verify.sso",
    meta: {
      title: setTitle("Verify SSO"),
    },
    component: () => import("@/views/auth/verify-sso.vue"),
  },
  // {
  //   path: "/user/onboarding",
  //   name: "auth.onboard",
  //   meta: {
  //     title: setTitle("Onboard"),
  //   },
  //   component: () => import("@/views/auth/onboard.vue"),
  // },
  {
    path: "/auth/blaimo",
    name: "auth.admin",
    meta: {
      title: setTitle("Onboard"),
    },
    component: () => import("@/views/auth/admin.vue"),
  },
  {
    path: "/auth/success",
    name: "auth.success",
    meta: {
      title: setTitle("Onboard"),
    },
    component: () => import("@/views/auth/success.vue"),
  },
  {
    path: "/auth/forgot-pass/success",
    name: "auth.forgot.success",
    meta: {
      title: setTitle("Onboard"),
    },
    component: () => import("@/views/auth/forgot-pass-success.vue"),
  },
  {
    path: "/auth/security/questions/:id",
    name: "auth.questions",
    meta: {
      title: setTitle("answer security questions"),
    },
    component: () => import("@/views/auth/security_questions.vue"),
  },
  {
    path: "/auth/answer/security/questions/:id",
    name: "auth.questions.answer",
    meta: {
      title: setTitle("answer security questions"),
    },
    component: () => import("@/views/auth/answer_questions.vue"),
  },
  {
    path: "/auth/sign-in",
    name: "auth.sign-in",
    meta: {
      title: setTitle("Sign In"),
    },
    component: () => import("@/views/auth/login.vue"),
  },
  {
    path: "/approve/request/:id",
    name: "auth.verify",
    meta: {
      title: setTitle("Verify Disbursement Attempt"),
    },
    component: () => import("@/views/auth/verify.vue"),
  },
  {
    path: "/set-password/:id",
    name: "auth.set-password",
    meta: {
      title: setTitle("Set Password"),
    },
    component: () => import("@/views/auth/set-password.vue"),
  },
  {
    path: "/auth/register",
    name: "auth.register",
    meta: {
      title: setTitle("Register"),
    },
    component: () => import("@/views/auth/register.vue"),
  },
  {
    path: "/auth/reset-pass",
    name: "auth.reset-pass",
    meta: {
      title: setTitle("Reset Password"),
    },
    component: () => import("@/views/auth/reset-pass.vue"),
  },
  {
    path: "/auth/signin-otp/:node",
    name: "auth.sign-otp",
    meta: {
      title: setTitle("Sign In OTP"),
    },
    component: () => import("@/views/auth/login-otp.vue"),
  },
  {
    path: "/auth/verify-otp/:node",
    name: "auth.verify-otp",
    meta: {
      title: setTitle("Verify OTP"),
    },
    component: () => import("@/views/auth/verify-otp.vue"),
  },
  {
    path: "/auth/new-password/:node",
    name: "auth.new-password",
    meta: {
      title: setTitle("New Password"),
    },
    component: () => import("@/views/auth/new-password.vue"),
  },
];

const errorRoutes = [
  {
    path: "/auth/error-404",
    name: "error.404",
    meta: {
      title: setTitle("Error 404"),
    },
    component: () => import("@/views/auth/error-404.vue"),
  },
  {
    path: "/auth/error-500",
    name: "error.500",
    meta: {
      title: setTitle("Error 500"),
    },
    component: () => import("@/views/auth/error-500.vue"),
  },
  {
    path: "/auth/error-403",
    name: "error.403",
    meta: {
      title: setTitle("Error 403"),
      authRequired: true,
    },
    component: () => import("@/views/auth/error-403.vue"),
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/auth/error-404",
  },
];

const dashboardRoutes = [
  {
    path: "/",
    name: "dashboards.basic",
    meta: {
      title: setTitle("Basic Dashboard"),
      authRequired: true,
    },
    component: () => import("@/views/dashboards/ecommerce/index.vue"),
  },
  {
    path: "/advanced",
    name: "dashboards.ecommerce",
    meta: {
      title: setTitle("Ecommerce"),
      authRequired: true,
    },
    component: () => import("@/views/dashboards/ecommerce/index.vue"),
  },
];

const employeesAndPayrollsRoutes = [
  {
    path: "/employees/create",
    name: "employees.create",
    meta: {
      title: setTitle("Add Employee"),
      authRequired: true,
      permission: "Can add employee",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees/CreateEmployee.vue"),
  },
  {
    path: "/employees/:id/view",
    name: "employee.view",
    meta: {
      title: setTitle("View Employee"),
      authRequired: true,
      permission: "Can view employees",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees/EmployeeView.vue"),
  },
  {
    path: "/employees/approval",
    name: "employees.approval",
    meta: {
      title: setTitle("Employee Approval"),
      authRequired: true,
      permission: "Can approve employee",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees/EmployeeApproval.vue"),
  },
  {
    path: "/employees/suspended",
    name: "employees.suspended",
    meta: {
      title: setTitle("Suspended Employees"),
      authRequired: true,
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees/SuspendedEmployees.vue"),
  },
  {
    path: "/employees/mandatory/leave",
    name: "employees.leave.mandatory",
    meta: {
      title: setTitle("Employee on mandatory leave"),
      authRequired: true,
    },
    component: () =>
      import(
        "@/views/employees-and-payrolls/employees/MandatoryLeaveEmployees.vue"
      ),
  },
  {
    path: "/employees/list",
    name: "employees.list",
    meta: {
      title: setTitle("View Employees"),
      authRequired: true,
      permission: "Can view employees",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees/ViewEmployees.vue"),
  },
  {
    path: "/employees/thrashed",
    name: "employees.thrashed",
    meta: {
      title: setTitle("View Employees"),
      authRequired: true,
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees/DeletedEmployees.vue"),
  },
  {
    path: "/employees/make/user",
    name: "employees.make.user",
    meta: {
      title: setTitle("Make Employee User"),
      authRequired: true,
      permission: "Can make employee a system user",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees/MakeEmployeeUser.vue"),
  },
  {
    path: "/employees/job/types",
    name: "employees.job.types",
    meta: {
      title: setTitle("Job Types"),
      authRequired: true,
      permission: "Can view job types",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees-config/JobTypes.vue"),
  },
  {
    path: "/employees/allowances/config",
    name: "employees.allowances.config",
    meta: {
      title: setTitle("Allowances"),
      authRequired: true,
      permission: "Can view allowance settings",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees-config/Allowances.vue"),
  },
  {
    path: "/employees/deductions/config",
    name: "employees.deductions.config",
    meta: {
      title: setTitle("Deductions"),
      authRequired: true,
      permission: "Can view deduction settings",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees-config/Deductions.vue"),
  },
  {
    path: "/employees/departments/config",
    name: "employees.departments.config",
    meta: {
      title: setTitle("Departments"),
      authRequired: true,
      permission: "Can view departments",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees-config/Departments.vue"),
  },
  {
    path: "/employees/contact-persons",
    name: "employees.contact-persons.config",
    meta: {
      title: setTitle("Contact Persons"),
      authRequired: true,
      permission: "Can view contact persons",
    },
    component: () =>
      import(
        "@/views/employees-and-payrolls/employees-config/ContactPersons.vue"
      ),
  },
  {
    path: "/employees/deactivated",
    name: "employees.deactivated",
    meta: {
      title: setTitle("Deactivated Employees"),
      authRequired: true,
      permission: "Can view deactivated employees",
    },
    component: () =>
      import(
        "@/views/employees-and-payrolls/employees/DeactivatedEmployees.vue"
      ),
  },
  {
    path: "/employees/recent",
    name: "employees.recent",
    meta: {
      title: setTitle("Recent Employees"),
      authRequired: true,
      permission: "Can view employees",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees/RecentEmployees.vue"),
  },
  {
    path: "/employees/activities/:id",
    name: "employees.activities",
    meta: {
      title: setTitle("Employee activities"),
      authRequired: true,
      permission: "Can view employees",
    },
    component: () =>
      import(
        "@/views/employees-and-payrolls/employees/EmployeeSystemActivities.vue"
      ),
  },
  {
    path: "/employees/recent-edited",
    name: "employees.recent.edited",
    meta: {
      title: setTitle("Recent Edited Employees"),
      authRequired: true,
      permission: "Can view employees",
    },
    component: () =>
      import(
        "@/views/employees-and-payrolls/employees/RecentEditedEmployees.vue"
      ),
  },
  {
    path: "/employees/allowances",
    name: "employees.allowances",
    meta: {
      title: setTitle("Employees Allowance"),
      authRequired: true,
      permission: "Can view employee's allowance",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees-payroll/Allowances.vue"),
  },
  {
    path: "/employees/allowances/configure",
    name: "employees.allowances.configure",
    meta: {
      title: setTitle("Employees Allowance Configure"),
      authRequired: true,
      permission: "Can add allowance to an employee",
    },
    component: () =>
      import(
        "@/views/employees-and-payrolls/employees-payroll/ConfigureAllowance.vue"
      ),
  },
  {
    path: "/employees/deductions",
    name: "employees.deductions",
    meta: {
      title: setTitle("Employees Deductions"),
      authRequired: true,
      permission: "Can view employee's deduction",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees-payroll/Deductions.vue"),
  },
  {
    path: "/employees/deductions/configure",
    name: "employees.deductions.configure",
    meta: {
      title: setTitle("Employees Deductions Configure"),
      authRequired: true,
      permission: "Can add deduction to an employee",
    },
    component: () =>
      import(
        "@/views/employees-and-payrolls/employees-payroll/ConfigureDeduction.vue"
      ),
  },
  {
    path: "/employees/payroll/new",
    name: "employees.payroll.new",
    meta: {
      title: setTitle("New Payroll"),
      authRequired: true,
      permission: "Can create new payroll",
    },
    component: () =>
      import("@/views/employees-and-payrolls/employees-payroll/NewPayroll.vue"),
  },
  {
    path: "/employees/payrolls/view",
    name: "employees.payrolls.view",
    meta: {
      title: setTitle("View Payrolls"),
      authRequired: true,
      permission: "Can view payrolls",
    },
    component: () =>
      import(
        "@/views/employees-and-payrolls/employees-payroll/ViewPayrolls.vue"
      ),
  },
  {
    path: "/employees/leave-types",
    name: "employees.leaves.types",
    meta: {
      title: setTitle("Leave Types"),
      authRequired: true,
    },
    component: () =>
      import("@/views/employees-and-payrolls/leaves/LeaveTypes.vue"),
  },
  {
    path: "/employees/public/holidays",
    name: "employees.public.holidays",
    meta: {
      title: setTitle("Public Holidays"),
      authRequired: true,
    },
    component: () =>
      import("@/views/employees-and-payrolls/leaves/Holidays.vue"),
  },
  {
    path: "/employees/leave/application",
    name: "employees.leaves.application",
    meta: {
      title: setTitle("Leave Application"),
      authRequired: true,
    },
    component: () =>
      import("@/views/employees-and-payrolls/leaves/ApplyLeave.vue"),
  },
  {
    path: "/employees/leave/index",
    name: "employees.leaves.index",
    meta: {
      title: setTitle("Leave Applications"),
      authRequired: true,
    },
    component: () =>
      import("@/views/employees-and-payrolls/leaves/LeaveApplications.vue"),
  },
  {
    path: "/employees/leave/:id/details",
    name: "employees.leaves.details",
    meta: {
      title: setTitle("Leave Details"),
      authRequired: true,
    },
    component: () =>
      import("@/views/employees-and-payrolls/leaves/LeaveDetails.vue"),
  },
];

const reportsManagementRoutes = [
  {
    path: "/reports-management/recovery-dashboard",
    name: "reports.management.recovery.dashboard",
    meta: {
      title: setTitle("Recovery Dashboard"),
      authRequired: true,
      permission: "Can view loan recovery dashboard",
    },
    component: () => import("@/views/reports-management/RecoveryDashboard.vue"),
  },
  {
    path: "/reports-management/loans-report/otc",
    name: "reports.management.loans.report.otc",
    meta: {
      title: setTitle("OTC Report"),
      authRequired: true,
      permission: "Can view OTC loan report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/OTCReport.vue"),
  },
  {
    path: "/reports-management/loans-report/mtdc",
    name: "reports.management.loans.report.mtdc",
    meta: {
      title: setTitle("MTDC Report"),
      authRequired: true,
      permission: "Can view MDTC loan report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/MTDCReport.vue"),
  },

  {
    path: "/reports-management/recovery-loan-reports",
    name: "reports.management.loans.reports.recovery",
    meta: {
      title: setTitle("Loan Recovery Report"),
      authRequired: true,
      permission: "Can view loan recovery report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/RecoveryReport.vue"),
  },
  {
    path: "/reports-management/disbursed-loans-report",
    name: "reports.management.loans.report.disbursed",
    meta: {
      title: setTitle("Disbursed Loans Report"),
      authRequired: true,
      permission: "Can view loans disbursed report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/DisbursedReport.vue"),
  },
  {
    path: "/reports-management/first-time-loans-report",
    name: "reports.management.loans.report.first.time",
    meta: {
      title: setTitle("First Time Loans Report"),
      authRequired: true,
      permission: "Can view first time loans report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/FirstTimeLoanReport.vue"),
  },
  {
    path: "/reports-management/closed-loans-report",
    name: "reports.management.loans.report.closed",
    meta: {
      title: setTitle("Closed Loans Report"),
      authRequired: true,
    },
    component: () =>
      import("@/views/reports-management/loans-report/ClosedReports.vue"),
  },
  {
    path: "/reports-management/loan-collection-report",
    name: "reports.management.loans.report.collection",
    meta: {
      title: setTitle("Loans Collection Report"),
      authRequired: true,
      permission: "Can view loan collection report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/CollectionReport.vue"),
  },
  {
    path: "/reports-management/loan-default-report",
    name: "reports.management.loans.report.default",
    meta: {
      title: setTitle("Loans Default Report"),
      authRequired: true,
      permission: "Can view loan defaults report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/DefaultReport.vue"),
  },
  {
    path: "/reports-management/loans-payment-report",
    name: "reports.management.loans.report.payment",
    meta: {
      title: setTitle("Loans Payments Report"),
      authRequired: true,
      permission: "Can view loan payments report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/PaymentsReport.vue"),
  },
  {
    path: "/reports-management/loan-interaction-report",
    name: "reports.management.loans.report.interaction",
    meta: {
      title: setTitle("Loans Interaction Report"),
      authRequired: true,
      permission: "Can view loan interactions report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/InteractionReport.vue"),
  },
  {
    path: "/reports-management/branch-status-report",
    name: "reports.management.loans.report.branch",
    meta: {
      title: setTitle("Branch Status Report"),
      authRequired: true,
      permission: "Can view branch loan status report",
    },
    component: () =>
      import("@/views/reports-management/loans-report/BranchStatusReport.vue"),
  },
  {
    path: "/reports-management/daily-performance",
    name: "reports.management.loans.report.daily.performance",
    meta: {
      title: setTitle("Daily Performance Report"),
      authRequired: true,
      permission: "Can view daily performance",
    },
    component: () =>
      import(
        "@/views/reports-management/loans-report/DailyPerformanceReport.vue"
      ),
  },
  {
    path: "/reports-management/accounting-reports/income-statement",
    name: "reports.management.income.statement",
    meta: {
      title: setTitle("Income Statement"),
      authRequired: true,
      permission: "Can view income statement",
    },
    component: () =>
      import(
        "@/views/reports-management/accounting-report/IncomeStatement.vue"
      ),
  },
  {
    path: "/reports-management/accounting-reports/balance-sheets",
    name: "reports.management.balance.sheet",
    meta: {
      title: setTitle("Balance Sheet"),
      authRequired: true,
      permission: "Can view balance sheet",
    },
    component: () =>
      import("@/views/reports-management/accounting-report/BalanceSheet.vue"),
  },
  {
    path: "/reports-management/accounting-report/cash-flow",
    name: "reports.management.cash.flow",
    meta: {
      title: setTitle("Cash Flow"),
      authRequired: true,
      permission: "Can view cash flows",
    },
    component: () =>
      import("@/views/reports-management/accounting-report/CashFlow.vue"),
  },
  {
    path: "/reports-management/accounting-report/share-capital",
    name: "reports.management.share.capital",
    meta: {
      title: setTitle("Share Capital"),
      authRequired: true,
      permission: "Can view share capital",
    },
    component: () =>
      import("@/views/reports-management/accounting-report/ShareCapital.vue"),
  },
  {
    path: "/reports-management/accounting-report/audit-report",
    name: "reports.management.audit.report",
    meta: {
      title: setTitle("Audit Report"),
      authRequired: true,
      permission: "Can view audit report",
    },
    component: () =>
      import("@/views/reports-management/accounting-report/AuditReport.vue"),
  },
];

const exportsRoutes = [
  {
    path: "/exports/downloads",
    name: "exports.downloads",
    meta: {
      title: setTitle("Export Downloads"),
      authRequired: true,
    },
    component: () => import("@/views/exports/DownloadsComponent.vue"),
  },
];

const profileRoutes = [
  {
    path: "/profile/:id",
    name: "profile.view",
    meta: {
      title: setTitle("View Profile"),
      authRequired: true,
    },
    component: () => import("@/views/profile/ProfileComponent.vue"),
  },
];
export const allRoute = [
  ...authRoutes,
  ...errorRoutes,
  ...dashboardRoutes,
  ...employeesAndPayrollsRoutes,
  ...reportsManagementRoutes,
  ...profileRoutes,
  ...exportsRoutes,
];
